import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../Button';
import Alert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { ReviewAPI } from '../../api';
import * as track from '../../lib/track';

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '1rem 0',
  },
  row: {
    width: '100%',
    padding: '0.5rem 0',
  },
  alert: {
    width: '100%',
    marginTop: '0.5rem',
  },
  button: {
    margin: '1rem 1rem 1rem 0',
  },
  label: {
    width: '100%',
    marginBottom: '1rem',
  },
});

const FeedbackForm = ({label='', onSuccess=null}) => {
  const classes = useStyles();
  const [busy, setBusy] = React.useState(false);
  const [content, setContent] = React.useState('');
  const [contentError, setContentError] = React.useState(null);
  const [submissionError, setSubmissionError] = React.useState(null);

  const validateContent = () => {
    const contentLength = content.length;
    const spaceCount = (content.split(' ').length - 1);
    if (contentLength > 10 && spaceCount > 4) {
      setContentError(null);
      return true;
    } else {
      setContentError('You must write at least 5 words in your feedback.');
      return false;
    }
  };

  const submit = async () => {
    setBusy(true);
    if (validateContent()) {
      try {
        await ReviewAPI.submitFeedback({content: content});
        track.sendEvent('feedback form', 'submit', {content: content});
        setBusy(false);
        if (onSuccess !== null) {
          onSuccess();
        }
      } catch (err) {
        console.log(err) // eslint-disable-line
        setSubmissionError('Oh no! We were unable to submit your feedback due to technical problems. Please try again later or contact us.');
        setBusy(false);
      }
    } else {
      setBusy(false);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        {label === '' ? null : (
          <Typography variant="body2" className={classes.label}>
            {label}
          </Typography>
        )}
        <TextField
          fullWidth
          required
          InputLabelProps={{
            shrink: true,
          }}
          value={content}
          variant="outlined"
          multiline
          rows={5}
          onChange={(event) => setContent(event.target.value)}
        />
        {contentError === null ? null : (
          <Alert severity="error" className={classes.alert}>
            {contentError}
          </Alert>
        )}
      </div>
      <div className={classes.row}>
        <Button
          variant="contained"
          disableRipple
          color="primary"
          onClick={submit}
          label="Submit"
          busy={busy}
          className={classes.button}
          pointer="right"
        />
        {submissionError === null ? null : (
          <Alert severity="error" className={classes.alert}>
            {submissionError}
          </Alert>
        )}
      </div>
    </div>
  );
};

FeedbackForm.propTypes = {
  label: PropTypes.string,
  onSuccess: PropTypes.func,
};

export default FeedbackForm;
